import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';

import { copyClaimToPreview, copyClaimToPreviewByCriteria } from '../../../store/actions/claimAnalysis';
import CopyClaimComponent from './CopyClaimDialog';

export const CopyClaimDialog = connect(
    () => {
        const selectPageRecord = createSelector(
            (state) => state.pages['claimAnalysis-landing'],
            (table) => table.page
        );

        const selectSignificance = createSelector(
            (state) => state.pages['claimAnalysis-landing'],
            (state,props) => props?.tableFiltersPtr?.value?.significance,

            (table,defaultSignficance) => {
                return (defaultSignficance!=null && defaultSignficance!=undefined) ? defaultSignficance : table.significance;
            }
        );

        return (state, props) => ({
            claimPageRecord: selectPageRecord(state),
            significanceFlag: selectSignificance(state,props),

            copyClaimToPreviewPending: state.claimAnalysis.copyClaim.pending,
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            copyClaimToPreview: copyClaimToPreview,
            copyClaimToPreviewByCriteria: copyClaimToPreviewByCriteria
        }, dispatch)
    })
)(injectIntl(CopyClaimComponent));